import {
  encodeRouteOrgId,
  shouldMaskOrgRouteParam,
} from "@/utils/routeIdCodec.js";

export function maskOrganizationRouteParam(to) {
  const id = String(to.params.id || "").trim();
  if (!shouldMaskOrgRouteParam(id)) return true;

  return {
    name: to.name,
    params: {
      ...to.params,
      id: encodeRouteOrgId(id),
    },
    query: to.query,
    hash: to.hash,
    replace: true,
  };
}
